<template>
  <div class="item" data-cy="schedule-tab-dateitem-container">
    <div class="d-flex flex-column" data-cy="schedule-tab-dateitem-content">
      <div
        class="cabecalho px-4 py-2 border"
        data-cy="schedule-tab-dateitem-header"
      >
        <strong class="text-primary" data-cy="schedule-tab-dateitem-dia">
          {{ scheduleday.data | moment("ddd") }}
        </strong>
        <strong data-cy="schedule-tab-dateitem-data">
          {{ scheduleday.data | moment("DD/MM") }}
        </strong>
      </div>
      <div
        :class="
          `celula px-4 py-2 border ${
            selected && selected.id === horarios.id ? 'bg-primary' : ''
          }`
        "
        v-for="horarios in this.scheduleday.profissionais[0].agendas[0]
          .horarios"
        :key="horarios.id"
        @click="select(horarios.id, horarios.hora, scheduleday.data)"
        :data-cy="`schedule-tab-dateitem-horario-${horarios.id}`"
      >
        <strong
          class="text-secondary active"
          :data-cy="`schedule-tab-dateitem-hora-${horarios.id}`"
        >
          {{ horarios.hora | moment("LT") }}
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "schedule-tab-dateitem",
  props: ["scheduleday", "step"],
  computed: {
    selected() {
      return this.$store.getters.get_selected[3];
    }
  },
  methods: {
    select(id, time, date) {
      let selected = {
        id: id,
        nome: `${moment(date).format("DD/MM")} às ${moment(time).format("LT")}`,
        date: time,
        medics: this.scheduleday.profissionais,
        stepId: 4
      };

      this.$store.dispatch("load_selected", selected);
      console.log(this.step);

      let payload = {
        name: this.step === 5 ? "consulta_profissional" : "consulta_paciente",
        params: { organizationId: this.$route.params.organizationId },
        query: {
          convenio: this.$route.query.convenio,
          especialidade: this.$route.query.especialidade,
          clinica: this.$route.query.clinica,
          horario: selected.id,
          ...(this.step === 6
            ? { medico: this.$store.getters.get_selected[5].id }
            : {})
        }
      };
      console.log(payload);

      this.$store.dispatch("set_to", payload);
      this.$store.commit("set_actualstep", this.step === 6 ? 5 : 4);
    }
  }
};
</script>

<style>
.celula {
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
  font-family: monospace;
  font-size: 1.2rem;
}
</style>
